// import wrapActions from '@/store/_wrap-actions'
import authService from '@/services/authentication'
import vueCookie from 'vue-cookie'
import store from '@/store'
// import HTTP from '@/services/http-request-handler'
const authModule = {
  state: {
    token: vueCookie.get('access-token') || '',
    status: '',
    count: 0
    // twoFACheck: store.state.ApiculusEnv.features.twoFactorAuth
  },

  mutations: {
    MUTATION_AUTH_SUCCESS: (state, token) => {
      state.status = 'success'
      state.token = token
    },
    MUTATION_AUTH_ERROR: (state) => {
      state.token = ''
      state.status = ''
      // store.replaceState(JSON.parse(localStorage.getItem('initialCopy')))
    },
    MUTATION_AUTH_LOGOUT: (state) => {
      state.token = ''
      state.status = ''
      // store.replaceState(JSON.parse(localStorage.getItem('initialCopy')))
    }
  },

  actions: {
    ACTION_AUTH_LOGIN: (context, credentials) => {
      let loginObject = {}
      if(credentials.istwoFactorEnabled) {
        loginObject = {
          email: credentials.email,
          password: credentials.password,
          otp: credentials.otp
        }
      } else {
        loginObject = {
          email: credentials.email,
          password: credentials.password,
          ott: credentials.ott
        }
      }
      let loginReq = authService.login(loginObject)
      return loginReq
    },
    ACTION_AUTH_LOGOUT: (context) => {
      let logoutReq = authService.logout()
      return logoutReq
    },
    ACTION_GET_STATE: (context, payload)=> {
      let stateData = authService.getState(payload)
      return stateData
    }
  },

  getters: {
    status: state => state.status
  }

}

export default authModule
